import DataTable from 'datatables.net-bs4';

// Initialize DataTables with jQuery
DataTable($);

import { locales } from './locales';

function initDocTable() {
  const $table = $('#docTable');
  if (!$table.length || $.fn.dataTable.isDataTable($table)) return;

  const locale = document.documentElement.lang;

  $table.DataTable({
    dom: 'lfrtip',
    oSearch: { bSmart: false, bRegex: true },
    lengthChange: false,
    pageLength: 15,
    columnDefs: [{ 'targets': 4, 'orderable': false }],
    order: [[3, 'desc']],
    language: locales[locale],
    initComplete: function () {
      let filterableColumns = this.api().columns([1, 2, 3]);
      filterableColumns.every(function () {
        let column = this;
        let columnName = column.header().textContent;
        let filterName = columnName == 'Date' ? locales[locale][columnName] : columnName;
        let columnId = columnName.split(' ').join('_');
        let removeFilterSelector = '#remove_filter_' + columnId;
        let currentSelect = $(
          '<select id=' + columnId + ' class="form-control form-select text-grey"><option value="" selected>' + filterName + '</option></select>'
        );

        var select = currentSelect
            .appendTo($('#docTable_filter'))
            .on('change', function () {
              var val = $.fn.dataTable.util.escapeRegex(
                $(this).val()
              );

              let current_column = this;

              val ? addClearAllLink() : $('#clearSelector').remove();

              // Reset all selected filters
              $('#clearSelector').on('click', (e) => {
                e.target.remove();

                filterableColumns.every(function () {
                  $('select.form-control').each(function() {
                    // set default value (column name)
                    this.selectedIndex = 0;
                  });
                  // get initial results
                  this.search('').draw();
                });
              });

              let regex = columnName == 'Date' ? val : '^'+val+'$';

              column
                .search(val ? regex : '', true, false)
                .draw();
            });

        var data = null;

        if (columnName == 'Date') {
          data = column.data().map((value) => {
            let array = value.split('/');

            // only keep date's year
            return array[array.length - 1];
          });
        } else {
          data = column.data();
        }

        data.filter(e =>  e).unique().sort().each((d, j) => {
          select.append('<option value="'+d+'">'+d+'</option>');
        });
      });
    }
  });

  function addClearAllLink() {
    $('#clearSelector').remove();

    if($('#clearSelector').length == 0) {
      $('#docTable_filter label').after('<a id=clearSelector>' + locales[locale]['clearAll'] + '</a>');
    }
  }
}

// Initialize on page load and Turbo navigation
document.addEventListener('DOMContentLoaded', initDocTable);
document.addEventListener('turbo:load', initDocTable);
